export default {
    name: "FormModal",
    props: {
        countCheck: {
            default:0
        },
        type: {
            default: "New",
            type: String,
        },
        activeDialog: {
            default: false,
            type: Boolean,
        },
        title: {
            required: true,
            type: String,
        },
        btnText: {
            default: "Salvar",
            type: String,
        },
    },

    data: () => ({
        dialog: false,
    }),

    watch: {
        activeDialog() {
            this.dialog = !this.dialog;
        },
    },
    methods: {
        close() {
            this.$emit("on-close");
            this.dialog = false;
        },

        save() {
            console.log(this.countCheck);
            if (this.type === "New") {
                this.$emit("on-save-new");
                return;
            }

            if (this.type === "Edit") {
                this.$emit("on-save-edit");
                return;
            }
        },
    },
};
